import React, { Component } from 'react';
import Header from '../Header';
import Menu from '../Menu';
import SubMenu from '../SubMenu';
import { Layout } from 'antd';

import { inject, observer } from 'mobx-react';
import s from './style.module.less';
import classnames from 'classnames';
import withRouter from '../withRouter';
// import { DoubleRightOutlined, DoubleLeftOutlined } from '@ant-design/icons';
import { registerMicroApps, start } from 'qiankun';
import { Navigate, Outlet } from 'react-router-dom';
// import { MenuUnfoldOutlined } from '@ant-design/icons';
import { subApps } from '@/utils/qiankunRoutes';
import { Display } from '../Display/Display';
import doubleArrow from '@/assets/images/doubleArrow.png';
const isLocal = process.env['REACT_APP_MODE'] === 'local',
    { Content, Sider } = Layout;

@inject('store')
@observer
class MainLayout extends Component {
    state = {
        isHaveRegister: false,
        collapsed: false,
        asideWidth: 244,
        showCollapsed: false
    };

    componentDidMount() {
        // this.sideResize();
        const props = this.props;

        if (props.platform.id && !this.state.isHaveRegister) {
            registerMicroApps(this.generateConfigByPlat());
            start({
                prefetch: false, //取消预加载
                sandbox: true,
                excludeAssetFilter: (assetUrl) => {
                    const whiteList = [],
                        whiteWords = ['baidu', 'map'];
                    if (whiteList.includes(assetUrl)) {
                        return true;
                    }
                    return whiteWords.some((w) => {
                        return assetUrl.includes(w);
                    });
                }
            });
            this.setState({
                isHaveRegister: true
            });
        }
    }
    //生成子应用的路由配置
    generateConfigByPlat = () => {
        const { global } = this.props.store;
        let { platform = {},platformOther={} } = global,
            res = subApps.map((ele) => {
                return {
                    name: `${platform.side_url}-${ele.prefix}`,
                    entry: isLocal ? ele.localEntry : ele.obsEntry,
                    container: '#qiankun-container',
                    activeRule: `/${platform.side_url}/${ele.prefix}`,
                    props: {
                        basename: `/${platform.side_url}/${ele.prefix}`,
                        sideObj:platformOther //角色管理页面权限接口需要反向查询
                    }
                };
            });
        return res;
    };
    //没有左侧菜单
    isNoAsider = (pathname) => {
        let paths = [
            '/manage/live-discussion-transition'
        ];
        return paths.some((item) => {
            return pathname.includes(item);
        });
    };
    //无左侧菜单无头部
    isNoAsiderAndHeader = (pathname) => {
        let paths = [
            '/manage/speciallyInvite/report/',
            '/manage/classroomInteractionEvaluation/'
        ];
        return paths.some((item) => {
            return pathname.includes(item);
        });
    };
    componentDidUpdate(preProps) {
        const pathname = this.props.location.pathname;
        if (this.props.location.pathname !== preProps.location.pathname) {
            //路由变化的时候 修改菜单的选中状态---监听不到home的状态
            this.props.store.menu.handleMenuState();
        }
        // 无左侧菜单
        if (
            (this.isNoAsider(pathname) &&
            this.props.store.global?.shareGlobalData?.showAsider) || (this.props.location?.search?.includes('noAsider') && this.props.store.global?.shareGlobalData?.showAsider)
        ) {
            const state = this.props.store.global?.shareGlobalData;
            state.showAsider = false;
            this.props.store.global.setGlobalState(state);
        }

        // 无导航，无头部
        if (
            (this.isNoAsiderAndHeader(pathname) &&
            this.props.store.global?.shareGlobalData?.showAsider) || (this.props.location?.search?.includes('noAll') && this.props.store.global?.shareGlobalData?.showAsider)
        ) {
            const state = this.props.store.global?.shareGlobalData;
            state.showAsider = false;
            state.showHeader = false;
            this.props.store.global.setGlobalState(state);
        }
    }
    debounce(func, delay) {
        let timer;
        return function () {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(null, arguments);
            }, delay);
        };
    }

    sideResize() {
        const div = document.querySelector('#menu-side');
        if (div) {
            let resizeHandler = this.debounce(() => {
                const divWidth = div.offsetWidth;
                if (this.state.asideWidth !== divWidth) {
                    this.setState({
                        asideWidth: divWidth + 16
                    });
                }
            }, 500);
            const resizeObserver = new ResizeObserver(resizeHandler);
            resizeObserver.observe(div);
        } else {
            this.setState({
                asideWidth: 0
            });
        }
    }
    getSideWith = (menu) => {
        if (menu.collapsed) {
            return '64px';
        }
        if (menu.menuState.outSelectMenu.id === 'home') {
            return '128px';
        }
        return '268px';
    };
    setCollapsed = () => {
        const { menu } = this.props.store;
        menu.setCollapsed(!menu.collapsed);
    };

    render() {
        const {
                login: { userInfo },
                global: {
                    shareGlobalData: { showAsider, showHeader }
                }
            } = this.props.store,
            { menu } = this.props.store;

        return (
            <>
                {userInfo.adminInfo === 1 ? <Navigate to="/error"></Navigate> : null}
                <Layout className={`${s.root} root`}>
                    <Display show={showAsider}>
                        <Sider id="menu-side" className={classnames(s['main-sider'])} width={this.getSideWith(menu)} theme="light">
                            <div className={s['menu-wrap']} style={{ display: 'flex' }}>
                                <Display show={!this.props.searchParams.get('hide_menu')}>
                                    <Menu />
                                </Display>

                                <Display show={showAsider && menu.menuState.outSelectMenu.id !== 'home' && !menu.collapsed}>
                                    <SubMenu />
                                </Display>
                                <div onClick={this.setCollapsed} className={s['arrow']} style={{ left: this.getSideWith(menu) }}>
                                    <img className={menu.collapsed ? s['img-reverse'] : ''} src={doubleArrow} alt="" />
                                </div>
                            </div>
                        </Sider>
                    </Display>

                    <Content
                        className={classnames(
                            s['box-content'],
                            menu.menuState.outSelectMenu.id === 'home' ? s['is-home'] : '',
                            showAsider ? '' : s['hide-aside'],
                            menu.collapsed ? s['collapsed'] : ''
                        )}
                    >
                        <Layout style={{ position: 'relative' }}>
                            <Display show={showHeader}>
                                <Header />
                            </Display>
                            <Content
                                className={classnames(
                                    'contentRef',
                                    s['main-content'],
                                    !showAsider ? `${s['hide-aside']}` : '',
                                    !showHeader ? `${s['hide-header']}` : ''
                                )}
                            >
                                <div id="qiankun-container">
                                    <Outlet></Outlet>
                                </div>
                            </Content>
                        </Layout>
                    </Content>
                </Layout>
            </>
        );
    }
}

export default withRouter(MainLayout);
